import { makeUseQueryHook } from '@graphql/functions'
import { EMPTY_SECTION_OF_THUMBNAILS } from '@graphql/placeholders'
import { GetSectionOfThumbnailsDocument } from '@graphql/queries/GetSectionOfThumbnails.graphql'

/**
 * Returns the content for a section of thumbnails.
 */
export const useSectionOfThumbnails = (id: string) => {
    const result = useGetSectionOfThumbnails({ variables: { id } })

    return {
        section: result.data?.section ?? EMPTY_SECTION_OF_THUMBNAILS,
        ...result,
    }
}

const useGetSectionOfThumbnails = makeUseQueryHook({
    query: GetSectionOfThumbnailsDocument,
})
